/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPackageUpdateData
 */
export interface SubscriptionPackageUpdateData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPackageUpdateData
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    maxUsers: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    maxIntegrations: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    maxDomains: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    dataUpdatesPerDay: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackageUpdateData
     */
    _public: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackageUpdateData
     */
    isArchived: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    monthlyCzk: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    yearlyCzk: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    monthlyEur: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    yearlyEur: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackageUpdateData
     */
    allowDiscountCodeEvaluation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackageUpdateData
     */
    allowInfluencerEvaluation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPackageUpdateData
     */
    allowAffiliateEvaluation: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageUpdateData
     */
    retentionMonths: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionPackageUpdateData
     */
    availableProjectIds: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof SubscriptionPackageUpdateData
     */
    features: object;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPackageUpdateData
     */
    internalNote?: string | null;
}

/**
 * Check if a given object implements the SubscriptionPackageUpdateData interface.
 */
export function instanceOfSubscriptionPackageUpdateData(value: object): value is SubscriptionPackageUpdateData {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('maxUsers' in value) || value['maxUsers'] === undefined) return false;
    if (!('maxIntegrations' in value) || value['maxIntegrations'] === undefined) return false;
    if (!('maxDomains' in value) || value['maxDomains'] === undefined) return false;
    if (!('dataUpdatesPerDay' in value) || value['dataUpdatesPerDay'] === undefined) return false;
    if ((!('_public' in (value as Record<string, any>)) && !('public' in (value as Record<string, any>))) || ((value as Record<string, any>)['_public'] === undefined && (value as Record<string, any>)['public'] === undefined)) return false;
    if (!('isArchived' in value) || value['isArchived'] === undefined) return false;
    if (!('monthlyCzk' in value) || value['monthlyCzk'] === undefined) return false;
    if (!('yearlyCzk' in value) || value['yearlyCzk'] === undefined) return false;
    if (!('monthlyEur' in value) || value['monthlyEur'] === undefined) return false;
    if (!('yearlyEur' in value) || value['yearlyEur'] === undefined) return false;
    if (!('allowDiscountCodeEvaluation' in value) || value['allowDiscountCodeEvaluation'] === undefined) return false;
    if (!('allowInfluencerEvaluation' in value) || value['allowInfluencerEvaluation'] === undefined) return false;
    if (!('allowAffiliateEvaluation' in value) || value['allowAffiliateEvaluation'] === undefined) return false;
    if (!('retentionMonths' in value) || value['retentionMonths'] === undefined) return false;
    if (!('availableProjectIds' in value) || value['availableProjectIds'] === undefined) return false;
    if (!('features' in value) || value['features'] === undefined) return false;
    return true;
}

export function SubscriptionPackageUpdateDataFromJSON(json: any): SubscriptionPackageUpdateData {
    return SubscriptionPackageUpdateDataFromJSONTyped(json, false);
}

export function SubscriptionPackageUpdateDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPackageUpdateData {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'maxUsers': json['maxUsers'],
        'maxIntegrations': json['maxIntegrations'],
        'maxDomains': json['maxDomains'],
        'dataUpdatesPerDay': json['dataUpdatesPerDay'],
        '_public': json['public'],
        'isArchived': json['isArchived'],
        'monthlyCzk': json['monthlyCzk'],
        'yearlyCzk': json['yearlyCzk'],
        'monthlyEur': json['monthlyEur'],
        'yearlyEur': json['yearlyEur'],
        'allowDiscountCodeEvaluation': json['allowDiscountCodeEvaluation'],
        'allowInfluencerEvaluation': json['allowInfluencerEvaluation'],
        'allowAffiliateEvaluation': json['allowAffiliateEvaluation'],
        'retentionMonths': json['retentionMonths'],
        'availableProjectIds': json['availableProjectIds'],
        'features': json['features'],
        'internalNote': json['internalNote'] === undefined ? undefined : json['internalNote'] === null ? null : json['internalNote'],
    };
}

export function SubscriptionPackageUpdateDataToJSON(json: any): SubscriptionPackageUpdateData {
    return SubscriptionPackageUpdateDataToJSONTyped(json, false);
}

export function SubscriptionPackageUpdateDataToJSONTyped(value?: SubscriptionPackageUpdateData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'maxUsers': value['maxUsers'],
        'maxIntegrations': value['maxIntegrations'],
        'maxDomains': value['maxDomains'],
        'dataUpdatesPerDay': value['dataUpdatesPerDay'],
        'public': value['_public'],
        'isArchived': value['isArchived'],
        'monthlyCzk': value['monthlyCzk'],
        'yearlyCzk': value['yearlyCzk'],
        'monthlyEur': value['monthlyEur'],
        'yearlyEur': value['yearlyEur'],
        'allowDiscountCodeEvaluation': value['allowDiscountCodeEvaluation'],
        'allowInfluencerEvaluation': value['allowInfluencerEvaluation'],
        'allowAffiliateEvaluation': value['allowAffiliateEvaluation'],
        'retentionMonths': value['retentionMonths'],
        'availableProjectIds': value['availableProjectIds'],
        'features': value['features'],
        'internalNote': value['internalNote'],
    };
}

